import React from 'react'
import Websection1 from '../../components/Webdesign/websection1/Websection1'
import Websection2 from '../../components/Webdesign/Websection2/Websection2'
import Websection3 from '../../components/Webdesign/Websection3/Websection3'
import Websection4 from '../../components/Webdesign/websection4/Websection4'
import Websection5 from '../../components/Webdesign/Websection5/Websection5'
import Websection6 from '../../components/Webdesign/Websection6/Websection6'
import Websection7 from '../../components/Webdesign/Websection7/Websection7'
import Websectionfooter from '../../components/Webdesign/Websectionfooter/Websectionfooter'
import Webtop from '../../components/Webdesign/Webtop/Webtop'

export default function Webdesign() {
  return (
    <div>
      <Webtop />
      <Websection1 />
      <Websection2 />
      <Websection3 />
      <Websection4 />
      <Websection5 />
      <Websection6 />
      <Websection7 />
      <Websectionfooter />
    </div>
  )
}
